export const PREVIEW_NOTIFICATION = {
  CHAT: 'chat',
  CUSTOMIZER: 'customizer',
};

export const DOCUMENTS_VIEW = {
  CLIENTS: 'clients',
  ROOT: 'root',
};
